import { useAxios } from "./useAxios"
import { Pagination } from "@/interfaces/Pagination"
import { useBot } from "./useBot"
import { Chat } from "@/interfaces/chats/Chat"
import { ChatMessageTypeEnum } from "@/enums/chats/messages/ChatMessageTypeEnum"

const axios = useAxios()

export interface GetAllChatsParams {
  page?: string
  perPage?: string
  search?: string
}

export interface SendChatMessageDTO {
  content: string
  type: ChatMessageTypeEnum
}

export function useChat() {
  const { selectedBot } = useBot()

  const getAll = async (params?: GetAllChatsParams): Promise<Pagination<Chat>> => {
    if (params) {
      params = Object.fromEntries(
        Object.entries(params).filter(([param, value]) => !!value)
      )
    }

    const response = await axios.get(`/bots/${selectedBot.value?.id}/chats`, { params })

    return response.data
  }

  const getByUuid = async (uuid: string): Promise<Chat> => {
      const response = await axios.get(`/bots/${selectedBot.value?.id}/chats/${uuid}`)
  
      return response.data
  }

  const read = async (chatId: number): Promise<void> => {
    const response = await axios.patch(`/bots/${selectedBot.value?.id}/chats/${chatId}/messages/read`)

    return response.data
  }

  const send = async (chatUuid: string, data: SendChatMessageDTO): Promise<void> => {
    const response = await axios.post(`/bots/${selectedBot.value?.id}/chats/${chatUuid}/messages`, data)

    return response.data
  }

  return {
    getAll,
    getByUuid,
    read,
    send
  }
}